export default {
  confirm: {
    cancelJob: 'Are you sure you want to cancel this job?',
    cancelJobRequest: 'Are you sure you want to cancel this job?',
    noShow: 'Please confirm that this person was a No Show',
    start: 'Are you sure this person is present/starting this job?',
    complete: 'Are you sure you want to mark this job as completed?',
  },
  messageAll: {
    header: 'Message All',
    note: 'This will send an in-app message to all Wonoloers working this Job. Wonoloers will not see each others’ responses.',
  },
  filters: {
    header: 'Filter',
    datesLabel: 'Date Range',
    ownerLabel: 'Job Owner',
    categoryLabel: 'Job Category',
    workerSearchPlaceholder: 'Search Wonoloer name',
    venueNameSearchPlaceholder: 'Search Location name',
    shiftNameSearchPlaceholder: 'Search Schedule name',
    clearAll: 'Clear All Filters',
    workerSearchLabel: 'Search',
    statusFilterLabel: 'Status',
    sortLabel: 'Sort By:',
    showAllWorkersOn: 'Show all workers',
    showAllWorkersOff: 'Hide all workers',
    filterAlerts: 'Show all alerts',
    unfilterAlerts: 'Hide all alerts',
    shifts: 'Schedules',
    jobCode: 'Job Code',
    jobCodeSearchPlaceholder: 'Search Job Code',
    position: 'Position',
    positionSearchPlaceholder: 'Search Position'
  },
  status: {
    active: 'Currently Active',
    approved: 'Approved',
    completed: 'Completed',
    notCheckedIn: "Hasn't Checked In",
    notCheckedOut: "Hasn't Checked Out",
    upcoming: 'Accepted',
    noShow: 'Absent',
    unfilled: 'Unfilled',
    pending: 'Pending...',
    autoClockOut: 'Auto Clock-out',
    notClockedIn: "Hasn't Clocked In",
    notClockedOut: "Hasn't Clocked Out",
    unpaidPersonalDay: 'Withdrawn (Unpaid Personal Day)',
  },
  statusLabels: {
    approved: 'APPROVED',
    readyToApprove: 'READY TO APPROVE',
    inProgress: 'IN PROGRESS',
    upcoming: 'UPCOMING',
    unfilled: 'UNFILLED',
    draft: 'DRAFT',
    cancelled: 'CANCELLED',
    tempToHire: 'TEMP-TO-HIRE'
  },
  statusFilterLabels: {
    approved: 'Approved',
    readyToApprove: 'Ready to Approve',
    inProgress: 'In Progress',
    upcoming: 'Upcoming',
    unfilled: 'Unfilled',
    draft: 'Draft',
    cancelled: 'Cancelled',
  },
  statusFilterValues: {
    inProgress: 'InProgress',
    readyToApprove: 'Completed',
  },

  jobRequestRow: {
    slotsFilledZero: '0 slots',
    slotsFilledSingle: '%numerator%/1',
    slotsFilledPlural: '%numerator%/%denominator%',
    slotsBonusWorkers: '+ %remainder% bonus workers',
    slotsBonusWorker: '+ %remainder% bonus worker',
    oneSlotAndWithdrawn: '%numerator%/1 Filled (Withdrawn)',
    multipleSlotsAndWithdrawn: '%numerator%/%denominator% Filled (%withdrawn% Withdrawn)',


    posterLabel: 'Posted by %name%',
    ownerLabel: 'Owned by %name%',

    closedPreferredLabel: 'Closed Preferred',

    buttonLabels: {
      edit: 'Edit Job',
      repost: 'Repost Job',
      details: 'Job Details',
      cancel: 'Cancel Job',
      message: 'Msg All',
      favorite: 'Favorite',
    },
    stateLabels: {
      draft: 'Draft',
      unassigned: 'Unassigned',
      posted: 'Posted',
      filled: 'Filled',
      inProgress: 'In Progress',
      complete: 'Completed',
      approved: 'Approved',
      unfilled: 'Unfilled',
      cancelled: 'Cancelled',
    },
    bulkAction: 'Bulk Action',
    bulkApprove: 'Approve',
    bulkAdjust: 'Adjust',
    toasts: {
      approveSuccess: "%workerName%'s job has been approved.",
      bulkApproveSuccess: '%numJobs% jobs have been approved.',
      approveError:
        "%workerName%'s job cannot be approved. Please make sure it has both clock in and out times.",
      bulkApproveError:
        '%numjobs% jobs cannot be approved. Please make sure it has both clock in and out times.',
      approvePendingJob:
        "%numJobs% job is awaiting approval from our system. You'll be notified when it's done.",
      approvePendingJobs:
        "%numJobs% jobs are awaiting approval from our system. You'll be notified when it's done.",
    },
    payType: {
      hourlyPay: 'Hourly Pay',
      flatRate: 'Flat Rate',
    },
  },
  lockedRoster: {
    wonoloerText: 'These preferred and favorite Wonoloers have accepted',
    infoText: "We'll provide more details %hours% %minutes% before the job starts",
  },
  jobRow: {
    startPin: 'Start PIN: %pin%',
    completePin: 'Complete PIN: %pin%',
    wandaPin: 'Wanda PIN: %pin%',
    buttonLabels: {
      adjust: 'Adjust',
      allowExtraTime: 'Allow Extra Time',
      allowedExtraTime: 'Allowed Extra Time',
      approve: 'Approve',
      block: 'Block',
      cancel: 'Cancel',
      clockOut: 'Clock Out',
      details: 'Details',
      message: 'Message',
      absent: 'Mark Absent',
      markedAbsent: 'Absent',
      clockIn: 'Clock In',
      unblock: 'Unblock',
      favorite: 'Favorite',
      favorited: 'Favorited',
    },
    modals: {
      clockIn: {
        header: 'What time did the Wonoloer start?',
        prompt: 'This job was scheduled to start at %startTime%.',
      },
      clockOut: {
        header: 'What time did the Wonoloer finish?',
        prompt: 'Please select a time between the time the Wonoloer clocked in (%clockInAt%) and now.',
      },
    },
    buttonToasts: {
      favorite: {
        success: '%name% has been favorited.',
        error: 'Something went wrong, please try again later.',
      },
      unfavorite: {
        success: '%name% has been unfavorited.',
        error: 'Something went wrong, please try again later.',
      },
      block: {
        success: '%name% has been blocked.',
        error: 'Something went wrong, please try again later.',
      },
      unblock: {
        success: '%name% has been unblocked.',
        error: 'Something went wrong, please try again later.',
      },
      allowExtraTime: {
        success: '%name% is marked "Allowed Extra Time".',
        error: 'Oops, something went wrong.',
      },
      notAllowExtraTime: {
        success: '%name% is no longer marked "Allowed Extra Time".',
        error: 'Oops, something went wrong.',
      },
    },
    totalPay: '%total% Total',
    coveredCosts: 'covered costs',
    workerStatus: {
      allowedExtraTime: '+Allowed Extra Time',
      autoClockedOut: 'Auto clocked-out',
      extraTime: 'Extra Time',
      present: 'Present',
    },
    tooltips: {
      allowExtraTime: 'Allow Wonoloer to work after scheduled end time.',
    },
    openClosedPreferred: {
      open: 'Open',
      modal: {
        header: 'Open Worker Pool',
        body1: "This job is currently limited to a preferred team. You have the option to open it to all eligible Wonoloers who meet the job's criteria.",
        body2: 'Do you want to open the worker pool and maximize your fill rate?',
        alert: 'This is a permanent action and can not be undone',
        approve: 'Yes, open worker pool'
      }
    }
  },
  page: {
    header: 'All Jobs',
    headerV2: 'Manage Jobs',
    panelHeader: 'Filter',
    noContentHeader: 'No jobs matched your search',
    noContentBody: 'Post a job or update your filters',
    noContentHeaderV2: 'No jobs posted',
    noResults: 'Try different keywords or revising filters',
    newJobButton: 'Post New Job',
    exportRoster: 'Export Roster',
    viewPinsButtonLabel: 'View Job PINs',
    rateButton: 'Rate & Pay',
  },
  lowRating: {
    disclaimer:
      'Your feedback is anonymous. The information is reviewed and aggregated by our team before anything is shared with Wonoloers.',
    cta: "Wonolo takes ratings seriously. To help us do better we would love feedback on %firstName%'s performance.",
  },
  jobsTable: {
    noWonoloersFound: 'No wonoloers found',
    worker: 'Wonoloers',
    workerStatus: 'Worker Status',
    totalCost: 'Wonoloer Pay',
    actions: 'Actions',
  },
  infoBar: {
    completed: {
      one: 'You have %count% Wonoloer job to approve. Filter jobs by',
      many: "You have %count% Wonoloers' jobs to approve. Filter jobs by",
      action: 'Status: Ready to Approve',
    },
    inProgress: {
      one: 'You have %count% Wonoloer job in progress. Filter jobs by',
      many: "You have %count% Wonoloers' jobs in progress. Filter jobs by",
      action: 'Status: In Progress',
    },
    alerts: {
      one: 'You have',
      many: 'You have',
      action: '%count% unread alerts',
    },
  },
};
